import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import Archive2022 from '../ClassAssembly2023/Archive2022';
import ClassAssemblySidebar2026 from '../ClassAssemblySidebar2026';

const ClassAssembly5B2026 = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const [config, setConfig] = useState({ base_image_url_2026: '' });
  useEffect(() => {
    fetch('/config.json')
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);

  const p1 = `${config.base_image_url_2026}/home/events-activities/class-assembly/5B/1.webp`;
  const p2 = `${config.base_image_url_2026}/home/events-activities/class-assembly/5B/2.webp`;
  const p3 = `${config.base_image_url_2026}/home/events-activities/class-assembly/5B/3.webp`;
  const p4 = `${config.base_image_url_2026}/home/events-activities/class-assembly/5B/4.webp`;



  const photos = [
    { src: p1, source: p1, rows: 1, cols: 1 },
    { src: p2, source: p2, rows: 1, cols: 1 },
    { src: p3, source: p3, rows: 1, cols: 1 },
    { src: p4, source: p4, rows: 1, cols: 1 },
  ];

  return (
    <Main>
      <Container>
        <Grid container spacing={4}>
          <Grid item xs={12} md={8}>
            <Box>
              <Box>
                <Typography variant="h4" align="center">
                    Smarter choices for a safer environment
                </Typography>
                <Typography fontSize="x-small">
                  <br />
                  <br />
                  Class: 5B   Date: 24 and 25 June 2026 
                </Typography>

        <Typography variant={'subtitle1'} align={'justify'}>
        The students of Class 5 presented their class assembly on Wednesday, 24 June and Thursday, 25 June 2026 on the theme
        <strong> “Smarter choices for a safer environment.”</strong>
                The assembly began with a thought that highlighted on the importance of
                preserving natural resources and how every small effort contributes to a greener and more sustainable future.
        <br></br>
                    The first day featured an informative speech on the significance of the environment, emphasizing that it is not just a
            responsibility of every one to preserve it but a necessity.
            <br></br>
                    On the second day, the students brought a message to the audience through a vibrant dance performance set to the
            song “Paryavaran Bachao.” Their energy and coordination showcased how we can help maintain a healthy and balanced
            ecosystem.
                    <br></br>
            It was very well received by the audience. During the concluding talk, the Principal emphasized on the duty of every
            individual to protect and preserve the environment for the well-being of all living beings. Whether through words,
            actions or spirit, we all have the ability to lead, inspire and make a difference.
        <br></br>
        </Typography>
              </Box>

            <Typography
                variant="h6"
                 color="primary"
                 align="center"
                 fontWeight="normal">
                <br />
                “A greater future begins with a wiser choice.”
                 <br />
            </Typography>

              <Box>
                <ImageList
                  variant="quilted"
                  cols={2}
                  rowHeight={isMd ? 200 : 100}
                  gap={isMd ? 16 : 4}
                >
                  {photos.map((item, i) => (
                    <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                      <LazyLoadImage
                        height={'100%'}
                        width={'100%'}
                        src={item.src}
                        alt="Class Assembly 5B 2026"
                        effect="blur"
                        onClick={() => openLightbox(i)}
                        style={{
                          objectFit: 'cover',
                          filter:
                            theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                          cursor: 'pointer',
                          borderRadius: 8,
                        }}
                      />
                    </ImageListItem>
                  ))}
                </ImageList>
              </Box>

              {viewerIsOpen && (
                <Lightbox
                  mainSrc={photos[currentImage].src}
                  nextSrc={photos[(currentImage + 1) % photos.length].src}
                  prevSrc={photos[(currentImage + photos.length - 1) % photos.length].src}
                  onCloseRequest={() => closeLightbox()}
                  onMovePrevRequest={() =>
                    setCurrentImage((currentImage + photos.length - 1) % photos.length)
                  }
                  onMoveNextRequest={() =>
                    setCurrentImage((currentImage + 1) % photos.length)
                  }
                  reactModalStyle={{ overlay: { zIndex: 1500 } }}
                />
              )}
            </Box>
          </Grid>

          <Grid item xs={12} md={4}>
            <Box marginBottom={4}>
              <ClassAssemblySidebar2026 />
            </Box>
            <Box marginBottom={4}>
              <Archive2022 />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Main>
  );
};

export default ClassAssembly5B2026;
